export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-die-five-613a67b0b82494c28b3cbd6444ea3875.svg";